/**
 * Etapa da execução em andamento, para o progresso na tela. Mesmos ids do catálogo
 * db_motor_fiscal.ibpt_etapa_execucao.
 */
export enum IbptEtapaExecucaoEnum {
    VerificandoVersao = 1,
    ConsultandoItens = 2,
    RepetindoItensComErro = 3,
    AguardandoNovaTentativa = 4,
    Gravando = 5,
}
